import { render, staticRenderFns } from "./OrganizationBasicForm.vue?vue&type=template&id=49ffe4f8&"
import script from "./OrganizationBasicForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports